import { Flex, Text } from "@radix-ui/themes";

export function CanvasLoadingPane() {
  return (
    <div className="flex h-full flex-col border-l border-puntt-accent-6/20 bg-puntt-neutral-gray-1">
      {/* Header */}
      <Flex
        align="center"
        gap="2"
        className="shrink-0 border-b border-puntt-neutral-gray-5 bg-base-white px-5 py-4"
      >
        <div className="h-2.5 w-2.5 animate-pulse rounded-full bg-puntt-accent-9 ring-2 ring-puntt-accent-4" />
        <Text size="3" weight="bold" className="text-puntt-neutral-gray-12">
          Generating&hellip;
        </Text>
      </Flex>

      {/* Skeleton content */}
      <div className="flex-1 overflow-y-auto p-6">
        <div className="space-y-6">
          {/* Title skeleton */}
          <div className="h-6 w-2/5 animate-pulse rounded bg-puntt-neutral-gray-4" />

          {/* Paragraph skeletons */}
          <div className="space-y-3">
            <div className="h-4 w-full animate-pulse rounded bg-puntt-neutral-gray-4" />
            <div className="h-4 w-11/12 animate-pulse rounded bg-puntt-neutral-gray-4" />
            <div className="h-4 w-4/5 animate-pulse rounded bg-puntt-neutral-gray-4" />
          </div>

          {/* Card skeleton */}
          <div className="rounded-lg border border-puntt-neutral-gray-4 p-4">
            <div className="space-y-3">
              <div className="h-4 w-1/3 animate-pulse rounded bg-puntt-neutral-gray-4" />
              <div className="h-4 w-3/4 animate-pulse rounded bg-puntt-neutral-gray-4" />
              <div className="h-4 w-1/2 animate-pulse rounded bg-puntt-neutral-gray-4" />
            </div>
          </div>

          {/* Another paragraph block */}
          <div className="space-y-3">
            <div className="h-4 w-full animate-pulse rounded bg-puntt-neutral-gray-4" />
            <div className="h-4 w-3/5 animate-pulse rounded bg-puntt-neutral-gray-4" />
          </div>
        </div>
      </div>
    </div>
  );
}
